import $ from 'jquery'

import Block from '../../common.blocks/block'

export default class Calendly extends Block {
	static title = 'calendly'

	static popupUrl =
		'https://calendly.com/zorgtotaalwinkel/showroombezoek?hide_event_type_details=1&hide_gdpr_banner=1&background_color=f9faf5&text_color=222222&primary_color=8aa84b'

	static listening = false

	constructor($el) {
		super($el)

		window.CalendlyPopupUrl = Calendly.popupUrl

		if (!Calendly.listening) {
			Calendly.listening = true
			Calendly.listen()
		}
	}

	// delegated, because triggers also live in markup loaded later (search dropdown)
	static listen() {
		$(document).on('click', `.${Calendly.title}`, (event) => {
			event.preventDefault()
			Calendly.open(event.currentTarget)
		})

		$(document).on('keydown', (event) => {
			if (event.key === 'Escape' && Calendly.$modal) {
				Calendly.close()
			}
		})
	}

	// inline embed instead of Calendly's popup: it reports its height, so the modal fits the content
	static open(trigger) {
		if (!window.Calendly) {
			window.open(Calendly.popupUrl, '_blank', 'noopener')
			return
		}
		if (Calendly.$modal) {
			return
		}

		Calendly.trigger = trigger
		Calendly.$modal = $(`
			<div class="calendly-modal" role="dialog" aria-modal="true" aria-label="Showroombezoek plannen">
				<button type="button" class="calendly-modal__close" aria-label="Sluiten"><i class="fa-regular fa-xmark" aria-hidden="true"></i></button>
				<div class="calendly-modal__content"></div>
			</div>
		`)

		Calendly.$modal.on('click', (event) => {
			if (event.target === event.currentTarget) {
				Calendly.close()
			}
		})
		Calendly.$modal
			.find('.calendly-modal__close')
			.on('click', () => Calendly.close())

		$('body').append(Calendly.$modal).addClass('calendly-modal-open')

		window.Calendly.initInlineWidget({
			url: Calendly.popupUrl,
			parentElement: Calendly.$modal.find('.calendly-modal__content').get(0),
			resize: true,
		})

		Calendly.$modal.find('.calendly-modal__close').trigger('focus')
	}

	static close() {
		Calendly.$modal?.remove()
		Calendly.$modal = null
		$('body').removeClass('calendly-modal-open')
		Calendly.trigger?.focus({ preventScroll: true })
	}
}
